export default __webpack_public_path__ + "static/kb_3_12-09527d4a47f0bb2f28ffbd7a964b147a.jpg";